import { render, staticRenderFns } from "./synchro.vue?vue&type=template&id=d0d3d5cc&scoped=true"
import script from "./synchro.vue?vue&type=script&lang=js"
export * from "./synchro.vue?vue&type=script&lang=js"
import style0 from "./synchro.vue?vue&type=style&index=0&id=d0d3d5cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d3d5cc",
  null
  
)

export default component.exports